import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Navigation } from '../Navigation';
import { IndexAudit } from '../indices/IndexAudit';
import { canAccessSymbol } from '../../lib/entitlements';

export const FuturesAudit: React.FC = () => {
  const { user } = useAuth();
  const hasEs  = canAccessSymbol(user as any, 'ES');
  const hasMes = canAccessSymbol(user as any, 'MES');

  if (!hasEs && !hasMes) {
    return (
      <div className="dashboard-container">
        <Navigation />
        <div style={{ maxWidth: 700, margin: '0 auto', padding: '3rem 1.5rem', textAlign: 'center', color: '#f9fafb' }}>
          <h2 style={{ marginBottom: '0.75rem' }}>Futures Audit</h2>
          <p style={{ color: '#9ca3af', maxWidth: 500, margin: '0 auto 1.5rem' }}>
            Track ES and MES research generation runs, AI analysis, and scoring decisions.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/upgrade" style={{ display: 'inline-block', backgroundColor: '#d97706', color: 'white', padding: '0.75rem 1.5rem', textDecoration: 'none', borderRadius: 8, fontWeight: 'bold', fontSize: 14 }}>ES Signals — $790/yr</a>
            <a href="/upgrade" style={{ display: 'inline-block', backgroundColor: '#16a34a', color: 'white', padding: '0.75rem 1.5rem', textDecoration: 'none', borderRadius: 8, fontWeight: 'bold', fontSize: 14 }}>MES Signals — $490/yr</a>
          </div>
          <p style={{ color: '#6b7280', fontSize: 13, marginTop: 12 }}>
            Or get everything with the <a href="/upgrade" style={{ color: '#a78bfa' }}>Bundle — $1,990/yr</a>
          </p>
        </div>
      </div>
    );
  }

  return <IndexAudit />;
};
